<template>
  <span style="display: inline-block; margin-left: 10px">
    <el-dropdown @command="showBatchActionsDialog">
      <el-button type="primary" size="small"
        >批量操作
        <i class="el-icon-arrow-down el-icon--right"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="confirm">审核通过</el-dropdown-item>
        <el-dropdown-item command="appealing">开启申诉</el-dropdown-item>
        <el-dropdown-item command="complete">任务完结</el-dropdown-item>
        <template v-if="isSelf">
          <el-dropdown-item command="showUploadDialog"
            >批量导入</el-dropdown-item
          >
          <el-dropdown-item command="exportTasksProgress"
            >导出任务进度</el-dropdown-item
          >
          <el-dropdown-item command="exportTaskScores"
            >导出任务扣分明细</el-dropdown-item
          >
          <el-dropdown-item command="exportPoint"
            >导出申诉的点</el-dropdown-item
          >
          <el-dropdown-item command="exportSelectPoint"
            >导出选中任务照片</el-dropdown-item
          >
          <el-dropdown-item command="exportCurrentDeductPoint"
            >导出当月扣分照片</el-dropdown-item
          >
          <el-dropdown-item command="exportCurrentAllPoint"
            >导出当月全部照片</el-dropdown-item
          >
        </template>
      </el-dropdown-menu>
    </el-dropdown>
    <el-dialog
      :visible.sync="actionsVisibles"
      width="30%"
      :before-close="cancel"
      append-to-body
      :title="title"
    >
      <el-form
        ref="dynamicValidateForm"
        label-width="120px"
        :rules="rules"
        v-if="action === 'appealing'"
      >
        <el-form-item label="申诉截止时间" prop="appeal_end_at">
          <el-date-picker
            v-model="form.appeal_end_at"
            type="datetime"
            placeholder="选择申诉截止时间"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="说明" prop="message">
          <el-input placeholder="请填写说明" v-model="form.message"></el-input>
        </el-form-item>
        <el-alert
          title="处于申诉中或已申诉的任务,可以重新设置申诉截止时间来延长或缩短申诉期"
          type="warning"
          show-icon
          :closable="false"
        >
        </el-alert>
      </el-form>
      <div class="" v-if="action === 'complete'">是否确定完结任务</div>
      <div class="" v-if="action === 'confirm'">是否确定审核通过该任务</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="taskEventActions">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 批量导入测评任务 -->
    <el-dialog
      title="导入测评任务"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div v-if="status === 'showUploadDialog'">
        <el-upload
          class="upload-demo"
          drag
          :action="uploadOption.url"
          :before-upload="beforeUpload"
          :on-success="uploadSuccess"
          :on-error="uploadError"
          multiple
          :data="uploadOption.requestBody"
          :file-list="uploadOption.fileList"
          accept=".xls,.xlsx"
          :headers="uploadOption.headers"
          :show-file-list="true"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        </el-upload>
        <span class="comment">
          说明：<br />
          (1) 必须与模板文件格式保持一致，如需模板文件请<a
            href="https://jinxin-public.oss-cn-hangzhou.aliyuncs.com/yuetu-android/task-template.xlsx"
            target="_blank"
            rel="noopener noreferrer"
          >
            点击此处</a
          >
          ；
          <br />
          (2)
          系统中已有相同编号的测评对象将会被<b>忽略</b>，但会刷新“更新时间”；<br />
          (3)
          系统中未存在的分组将会被自动创建；因此不能写错字、少字，例如“瑞安市”不能写成“瑞安”。
        </span>
      </div>
      <div v-else></div>
    </el-dialog>
  </span>
</template>

<script>
import {
  taskActions,
  taskBatchActions,
  exportPoints,
  exportTaskMedias,
  exportTasksProgress,
  exportTaskScores,
} from "@/api/project";
import { getCookies } from "@/util/auth";
import moment from "moment";
export default {
  props: {
    // 选中的 Task 列表
    selectedTasks: {
      type: Array,
      default: () => [],
    },
    // 当前选中的 Round
    currentRound: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      actionsVisibles: false,
      form: {
        message: "",
        appeal_end_at: "",
      },
      status: "",
      type: "",
      title: "",
      action: "",
      rules: {
        message: [
          { required: false, message: "请输入审核说明", trigger: "blur" },
        ],
        appeal_end_at: [
          { required: false, message: "请输入申诉截止时间", trigger: "blur" },
        ],
      },
      //可以操作列表
      operateList: [],

      titles: "",

      // 批量导入
      dialogVisible: false,
      uploadOption: {
        fileList: [],
        url: process.env.VUE_APP_API_PREFIX + "pr/tasks/_import",
        requestBody: {
          round_id: null,
          success_action_status: 200,
        },
        headers: {
          Authorization: "Bearer " + getCookies("Access-Token"),
          accept: "multipart/form-data",
        },
      },

      // 批量导出多个测评点
    };
  },
  computed: {
    isSelf() {
      return (
        this.$store.getters.role === "owner" ||
        this.$store.getters.role === "admin"
      );
    },
  },
  methods: {
    exportSelectPoint() {
      //选中的数据
      let selectId = this.selectedTasks.map((item) => item.id);
      // 当月
      let currentRoundId = this.currentRound.id;

      exportTaskMedias({
        round_id: currentRoundId,
        task_ids: selectId,
      })
        .then((res) => {
          window.open(res.data.download_url, "_self");
        })
        .catch((err) => {
          this.$message.error("文件下载失败");
        });
    },
    // 当月扣分的照片
    exportCurrentDeductPoint() {
      // 当月
      let currentRoundId = this.currentRound.id;
      exportTaskMedias({
        round_id: currentRoundId,
        type: "scored",
      })
        .then((res) => {
          window.open(res.data.download_url, "_self");
        })
        .catch((err) => {
          this.$message.error("文件下载失败");
        });
    },
    // 当月所有的照片
    exportCurrentAllPoint() {
      // 当月
      let currentRoundId = this.currentRound.id;
      exportTaskMedias({
        round_id: currentRoundId,
      })
        .then((res) => {
          window.open(res.data.download_url, "_self");
        })
        .catch((err) => {
          this.$message.error("文件下载失败");
        });
    },

    // 导出任务进度
    exportTasksProgress() {
      exportTasksProgress({
        round_id: this.currentRound.id,
      })
        .then((res) => {
          window.open(res.data.url, "_self");
        })
        .catch((err) => {
          this.$message.error("文件下载失败");
        });
    },

    // 导出任务得分细则
    exportTaskScores() {
      const time = Date.now();
      const loading = this.$loading({
        lock: true,
        text: "正在下载中，如需重新下载请刷新页面......",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let num = 0;
      let timers = setInterval(() => {
        if (num % 10 === 0) {
          exportTaskScores({
            round_id: this.currentRound.id,
            tid: time,
          })
            .then((res) => {
              if (res.data.completed) {
                window.open(res.data.url, "_self");
                loading.close();
                clearInterval(timers);
                timers = null;
              }
            })
            .catch((err) => {
              this.$message.error("文件下载失败");
              loading.close();
              clearInterval(timers);
              timers = null;
            });
        }
      }, 10000);
    },
    // 批量导入
    showUploadDialog() {
      this.dialogVisible = true;
      this.uploadOption.requestBody.round_id = this.currentRound.id;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    uploadError(err) {
      this.$message({
        type: "error",
        message: "上传失败",
        center: true,
        duration: 1500,
      });
    },
    uploadSuccess(response, file, fileList) {
      this.$message({
        type: "success",
        message: "上传成功",
        center: true,
        duration: 1500,
      });
      this.dialogVisible = false;
      this.$emit("success");
    },
    beforeUpload(file) {
      const url = file.name;
      const index = url.lastIndexOf(".");
      const suffix = url.substring(index + 1, url.length).toUpperCase();
      const type = ["XLS", "XLSX"];
      // console.log(suffix);
      if (type.indexOf(suffix) == -1) {
        this.$message({
          type: "error",
          message: "请上传指定类型的文件",
          center: true,
          duration: 1500,
        });
        return false;
      }
    },
    taskEventActions() {
      let action = this.action;
      if (action === "reject" && !this.form.message.length) {
        this.$message({
          type: "error",
          message: "请填写说明信息",
        });
        return;
      }
      if (this.type === "taskActions") {
        let id = this.selectedTasks[0].id;
        taskActions({
          action,
          id,
          message: this.form.message,
          appeal_end_at: this.form.appeal_end_at,
        }).then((res) => {
          this.$emit("success", this.type);
          this.$message({
            type: "success",
            message: "审核提交成功",
          });
          this.cancel();
        });
      } else {
        let ids = this.operateList.map((item) => item.id);
        taskBatchActions({
          action,
          ids,
          message: this.form.message,
          appeal_end_at: this.form.appeal_end_at,
        })
          .then((res) => {
            this.$emit("success", this.type);
            this.$message({
              type: "success",
              message: res.message,
            });
            this.cancel();
          })
          .catch((err) => {
            this.$message({
              type: "error",
              message: err.message,
            });
          });
      }
    },
    cancel() {
      this.actionsVisibles = false;
      this.status = "";
      this.type = "";
      this.action = "";
      this.form.message = "";
      this.form.appeal_end_at = "";
      this.title = "";
      this.operateList = [];
      if (this.$refs.tabsView) {
        this.$refs.tabsView.clearSelect();
      }
      this.$emit("closeDialog");
    },

    showBatchActionsDialog(status) {
      this.status = status;
      if (status === "exportPoint") {
        const loading = this.$loading({
          lock: true,
          text: "文件生成中，文件较大时，可能要等待较长时间",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        exportPoints({ round_id: this.currentRound.id })
          .then((res) => {
            loading.close();
            this.visible = false;
            window.open(res.data.url, "_self");
          })
          .catch(() => {
            loading.close();
            this.$message.error("文件下载失败");
          });
        return;
      }

      if (
        status === "exportCurrentDeductPoint" ||
        status === "exportCurrentAllPoint" ||
        status === "exportSelectPoint" ||
        status === "showUploadDialog"
      ) {
        this[status]();
        return;
      }

      // 导出各任务进度
      if (status === "exportTasksProgress") {
        this.exportTasksProgress();
        return;
      }

      // 导出各任务得分细则
      if (status === "exportTaskScores") {
        this.exportTaskScores();
        return;
      }

      if (!this.selectedTasks.length) {
        this.$message.error("请选择任务");
        return;
      }

      this.type = "batchActions";
      let data = this.selectedTasks.filter((item) =>
        this.filterStatus(status, item, false)
      );
      this.action = status;
      this.actionsVisibles = !!data.length;
      this.$message({
        type: data.length ? "success" : "error",
        message: data.length
          ? `您选中的有 ${data.length} 个任务可以进行批量操作`
          : "您选中的任务无法进行批量操作",
      });
      this.operateList = data;
    },
    showDialog(type, taskData, status) {
      let isFlag = this.filterStatus(status, taskData);
      if (isFlag) {
        this.type = type;
        this.action = status;
        this.actionsVisibles = isFlag;
      }
    },

    // 为不同的 action 筛选符合的 status
    filterStatus(type, task, show = true) {
      // let isFlag = moment().isBefore(task.appeal_end_at, "day");
      // if (isFlag) {
      //   return false;
      // }
      // console.log(type, task.status, show, task);
      if (type === "reject" && task.status === "uploaded") {
        this.title = "打回重测";
        return true;
      } else if (
        type === "confirm" &&
        (task.status === "uploaded" || task.status === "reviewed")
      ) {
        this.title = "审核通过";
        return true;
      } else if (
        type === "complete" &&
        (task.status === "appealing" || task.status === "appealed")
      ) {
        this.title = "完结";
        return true;
      } else if (
        type === "appealing" &&
        (task.status === "confirmed" ||
          task.status === "appealing" ||
          task.status === "appealed")
      ) {
        this.title = "开启申诉期";
        return true;
      } else {
        show &&
          this.$message({
            type: "error",
            message: "当前任务无法进行审核操作",
          });
        return false;
      }
    },
  },
};
</script>

<style>
.taskObjectTable {
  height: 760px;
  display: flex;
}

.subjectTree {
  width: 240px;
}

.subjectList {
  width: 1100px;
}

.demo-dynamic .el-form-item {
  margin-bottom: 0 !important;
}
</style>
